import Question from 'models/Question';
import React from 'react';
import MultipleChoiceOption from 'models/MultipleChoiceOption';
import ActionButton from 'view/components/buttons/ActionButton';
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons';
import MultipleChoiceOptionEditor from '../../questions/MultipleChoiceOptionEditor';

import 'view/style/teacher/components/assignment/newcomer.css';

interface MultipartOrderingFrameProps {
  question: Question;
  onUpdateQuestion: (
    updatedQuestion: Question,
    submit?: boolean,
    image?: File,
  ) => void;
}

const MultipartOrderingFrame: React.FC<MultipartOrderingFrameProps> = ({
  question,
  onUpdateQuestion,
}) => {
  const handleDeleteQuestionChoice = (question: any, choice: any) => {
    const updatedChoices = [
      ...(question.choices ?? []).filter(
        (c: MultipleChoiceOption) => Number(c.id) !== Number(choice.id),
      ),
    ].sort((c1, c2) => c1.index - c2.index);

    updatedChoices.forEach((choice, index) => {
      choice.index = index + 1; // Set the index to 1-based
    });

    const updatedQuestion = Question.fromQuestion(question);
    updatedQuestion.choices = updatedChoices;
    updatedQuestion.question_type =
      !updatedChoices.length && question.question_type !== 'listening'
        ? 'text'
        : question.question_type;

    onUpdateQuestion(updatedQuestion);
  };

  const handleModifyQuestionChoice = (
    question: Question,
    choice: MultipleChoiceOption,
    text: string,
    correct: boolean,
  ) => {
    const updatedChoice = new MultipleChoiceOption(
      choice.id,
      choice.question,
      text,
      correct,
      choice.index,
      choice.img,
      choice.img_file,
    );
    const updatedQuestion = Question.fromQuestion(question);
    const choiceIdx = question.choices?.findIndex(
      (c) => c.id === choice.id,
    ) as number;
    updatedQuestion.choices = [
      ...question.choices!.slice(0, choiceIdx),
      updatedChoice,
      ...question.choices!.slice(choiceIdx + 1),
    ];

    onUpdateQuestion(updatedQuestion, false);
  };

  const handleAddQuestionChoice = () => {
    const updatedQuestion = Question.fromQuestion(question);

    updatedQuestion.choices = [
      ...(updatedQuestion.choices ?? []),
      new MultipleChoiceOption(
        updatedQuestion.choices?.length.toString() ?? '0',
        question.id,
        '',
        false,
        (updatedQuestion.choices?.length ?? 0) + 1,
      ),
    ];

    onUpdateQuestion(updatedQuestion);
  };

  const handleReorderQuestionChoices = (
    reorderedChoices: MultipleChoiceOption[],
  ) => {
    const updatedQuestion = Question.fromQuestion(question);
    updatedQuestion.choices = reorderedChoices;
    onUpdateQuestion(updatedQuestion, true);
  };

  return (
    <div className="multi-part-assignment-component">
      <div className="user-input-label" style={{ alignSelf: 'stretch' }}>
        <label className="label-small" htmlFor={`${question.index}-prompt`}>
          Question {question.index}
        </label>
      </div>
      <MultipleChoiceOptionEditor
        question={question}
        choices={question.choices ?? []}
        onModifyQuestionChoice={handleModifyQuestionChoice}
        onDeleteQuestionChoice={handleDeleteQuestionChoice}
        onReorderQuestionChoices={handleReorderQuestionChoices}
        allowImages={false}
        allowCorrectChoices={false}
      />
      <ActionButton
        type="go"
        icon={faPlusSquare}
        onClick={() => handleAddQuestionChoice()}
        label="Add choice"
      />
    </div>
  );
};

export default MultipartOrderingFrame;
